import { MetrikMotifModel, MetrikMotifRelationModel } from '../models/metrik-motif.model';

/** Helpers d'affichage des motifs Metrik (PRED-3288), partagés par les listes / détails des génériques et les modales. */
export class MetrikMotifHelper {
  /** « Surcroît, Remplacement » */
  static labels(motifs?: MetrikMotifRelationModel[]): string {
    return (motifs ?? []).map(motif => motif.label).join(', ');
  }

  /** « Surcroît (Compétence, Bâtiment) » pour les sélecteurs où plusieurs typologies cohabitent. */
  static display(motif: MetrikMotifModel): string {
    const types = (motif.types ?? []).join(', ');
    return types ? `${motif.label} (${types})` : motif.label;
  }

  /** Réduit la sélection aux champs persistés. */
  static toRelations(motifs?: Array<MetrikMotifModel | MetrikMotifRelationModel>): MetrikMotifRelationModel[] {
    return (motifs ?? []).map(motif => ({ _id: motif._id, label: motif.label, types: motif.types }));
  }

  /** mat-select multiple compare par référence : ré-associe les relations enregistrées aux items chargés. */
  static matchSelected(items: MetrikMotifModel[], selected?: MetrikMotifRelationModel[]): MetrikMotifModel[] {
    const ids = new Set((selected ?? []).map(motif => motif._id));
    return items.filter(item => ids.has(item._id));
  }
}
